// src/BoardPage.jsx
import React from 'react';
import PageHeader from './PageHeader';
import styles from './BoardPage.module.css'; // Create this next

const BoardPage = () => {
  const founders = [
    { name: 'Biama Nyaga Ndathi', role: 'Councillor Municipal Runyenjes' },
    { name: 'Lawrence Njuki M`thika', role: 'Chairman' },
    { name: 'Matthew Nyaga Kaviri', role: 'Secretary' },
    { name: 'Agnes Kaari Nthiga', role: 'Treasurer' },
    { name: 'Biama Nyaga Ndathi', role: 'Councillor Municipal Runyenjes' },
    { name: 'Henry W. Ngare M`Njine', role: '' },
    { name: 'Elias Ndwiga Ngari', role: '' },
    { name: 'Nahashon Njagi', role: 'Chief Kagaari Location' },
    { name: 'Amos Njeru Ezekiel', role: '' },
  ];

  const presentCommittee = [
    { name: 'Biama Nyaga Ndathi', role: 'Chairman' },
    { name: 'John Kaithiru Gichonge', role: 'Vice Chairman' },
    { name: 'Amos Njeru Ezekiel', role: 'Vice Chairman (Late)' },
    { name: 'Henry Ngare M`Njine', role: 'Secretary' },
    { name: 'Peter Nyaga M`tathi', role: 'Vice Secretary' },
    { name: 'Patrick Ndwiga Kabuthi', role: 'Vice Secretary (Retired)' },
    { name: 'Seth Njagi Ezekiel', role: 'Treasurer' },
    { name: 'Canon Mwaniki Josiah Nyaga', role: 'Treasurer (Retired)' },
    { name: 'Lawrence Njuki M`thika', role: 'Treasurer (Late)' },
    { name: 'Nicospus Njeru Tirous', role: 'Vice Treasurer' },
    { name: 'Elias Ndwiga Ngari', role: 'Vice Treasurer (Late)' },
    { name: 'Hoseah Nyaga Douglas', role: '' },
    { name: 'Canon John Mwaniki Gichangi', role: '' },
    { name: 'Nicholas Njeru Ayub', role: 'Councillor Municipal Runyenjes' },
    { name: 'Jeshurah Warue Benjamin', role: '' },
    { name: 'Rebecca Igandu Njiru', role: '' },
    { name: 'Laurentius Warue Kariri', role: '' },
  ];

  return (
    <div className={styles.container}>
      <PageHeader
        title="Board of Founders & Committee Members"
        subtitle="Honoring our pioneers and current leaders who built and sustain our society."
      />
     

      {/* Founders Section */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Honours Board (Founders 1986-2000)</h2>
        <div className={styles.grid}>
          {founders.map((member, index) => (
            <div key={index} className={styles.card}>
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Present Committee */}
      <section className={styles.sectionAlt}>
        <h2 className={styles.sectionTitle}>Present Committee (2001-Present)</h2>
        <div className={styles.grid}>
          {presentCommittee.map((member, index) => (
            <div key={index} className={styles.card}>
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </div>
          ))}
        </div>
      </section>

      <footer className={styles.footer}>
        <p>&copy; {new Date().getFullYear()} Kigaa Self-Help Water Society.</p>
      </footer>
    </div>
  );
};

export default BoardPage;